import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";
import useQuery, { useRevalidate } from "./useQuery";
import { useChannel } from "./ws/useChannel";

const PATH = "/users";
export const useUsers = () => {
  const revalidate = useRevalidate();

  const users = useQuery(PATH).body;
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH);
    },
    [revalidate],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "users" }, callback, true);
  return users;
};

export type Users = ReturnType<typeof useUsers>;
export type UserProfil = Users[number];
export type UserRole = Users[number]["roles"]["global"];
export type UserProject = Users[number]["roles"]["projects"][number];
